
<style lang="less">
@import "../less/common.less";
@import "./priceAnalysis.less";
.active {
  visibility: hidden;
  height: 0px !important;
  margin-bottom: 0px !important;
}
</style>
<template>
  <!-- <div>价格带分析</div> -->
  <el-row :gutter="20"
          class="priceAnalysis row-bg common-layout"
          justify="space-between">
    <el-col class="common-layout-r"
            id="search-content-h"
            :span="24">
      <div class="search-txt">
        <el-form :label-position="labelPosition"
                 label-width="80px"
                 :model="formLabelAlign">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="日期:"
                            class="common-date-picker">
                <el-date-picker v-model="startTime"
                                type="date"
                                placeholder="开始日期"
                                :picker-options="pickerOptionsStart"
                                :clearable="false"
                                :editable="false"
                                size="medium"
                                @change="changeStart"></el-date-picker>
                <el-date-picker v-model="endTime"
                                type="date"
                                placeholder="结束日期"
                                :picker-options="pickerOptionsEnd"
                                @change="changeEnd"
                                :editable="false"
                                size="medium"
                                :clearable="false"></el-date-picker>
                <div class="picker-ico">至</div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="区域:">
                <template v-if="deptAreaList.length">
                  <el-select v-model="areaId"
                             collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             size="medium"
                             @change="changeArea">
                    <el-option v-for="item in deptAreaList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id"></el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             size="medium"
                             @change="changeArea">
                    <el-option v-for="item in deptAreaList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="门店:">
                <template v-if="optionsDept.length">
                  <el-select v-model="valueDept"
                             collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             :clearable="true"
                             size="medium"
                             @change="selectDeptAll">
                    <el-option v-for="item in optionsDept"
                               :key="item.deptId"
                               :label="item.deptName"
                               :value="item.deptId"></el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             :clearable="true"
                             size="medium"
                             @change="selectDeptAll">
                    <el-option v-for="item in optionsDept"
                               :key="item.deptId"
                               :label="item.deptName"
                               :value="item.deptId"></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="中类:">
                <template v-if="typeList1.length">
                  <el-select v-model="productTypeId1"
                             collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             size="medium"
                             @change="changeProductType1">
                    <el-option v-for="item in typeList1"
                               :key="item.productTypeId"
                               :label="item.productTypeName"
                               :value="item.productTypeId"></el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             size="medium"
                             @change="changeProductType1">
                    <el-option v-for="item in typeList1"
                               :key="item.productTypeId"
                               :label="item.productTypeName"
                               :value="item.productTypeId"></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="小类:">
                <template v-if="optionsProductType.length">
                  <el-select v-model="valueProductType"
                             collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             :clearable="true"
                             size="medium"
                             @change="selectAll">
                    <el-option v-for="item in optionsProductType"
                               :key="item.productTypeId"
                               :label="item.productTypeName"
                               :value="item.productTypeId"></el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             :clearable="true"
                             size="medium"
                             @change="selectAll">
                    <el-option v-for="item in optionsProductType"
                               :key="item.productTypeId"
                               :label="item.productTypeName"
                               :value="item.productTypeId"></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="价格区间:"
                            class="common-price">
                <div class="common-price-content">
                  <el-input size="medium"
                            @keyup.native="proving1(index)"
                            v-model="price1"></el-input>
                  <div class="price-ico">至</div>
                  <el-input size="medium"
                            @keyup.native="proving2(index)"
                            v-model="price2"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item class="radio-type">
                <el-radio-group v-model="radio"
                                @change="redioChange">
                  <el-radio size="medium"
                            :label="0">价格</el-radio>
                  <el-radio size="medium"
                            :label="1">价格段区间</el-radio>
                </el-radio-group>
                <span class="edit"
                      @click="openEdit">修改价格段区间</span>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">&nbsp;</el-col> -->
            <el-col :span="6">
              <el-form-item class="check-btn">
                <el-checkbox size="medium"
                             v-model="checkedBQ">显示商品标签</el-checkbox>
                <!-- <div>
                <p>说明：</p>
                <p>1、该表单是门店内所有在售商品及其价格分布一览</p>
                <p>2、您可以根据该分析表调整整体的价格策略</p>
                <p>3、点击小蓝点可查看详情</p>
                </div>-->
                <!-- <el-button class="share-button"
                           icon="el-icon-share"
                           type="primary"></el-button> -->
                <el-button type="primary"
                           size="small"
                           @click="getProductPriceZone()">搜索</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="24"
                    style="height: 280px;padding-top:10px"
                    v-bind:class="{ active:radio==1}">
              <div ref="dom1"
                   class="charts chart-bar"
                   style="height: 288px;width: 100%;"></div>
              <div ref="dom2"
                   class="charts chart-bar"
                   style="height: 288px;width: 100%;position: absolute;margin-top: -10px;z-index:99"></div>
            </el-col>
            <el-col :span="24"
                    style="height: 280px;padding-top:10px"
                    v-bind:class="{ active:radio==0}">
              <div ref="dom3"
                   id="myChart"
                   class="charts chart-bar"
                   style="height: 288px;width: 100%;z-index: 99;"></div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="search-content">
        <el-table class="table-common"
                  :data="tableData"
                  border
                  :row-class-name="tableRowClassName"
                  :cell-style="cellStyle"
                  :resizable="false"
                  highlight-current-row>
          <el-table-column label-class-name="product-data-index"
                           type="index"
                           label
                           align="center"
                           width="50"></el-table-column>
          <el-table-column prop="productCode"
                           label="编码"
                           header-align="center"></el-table-column>
          <el-table-column prop="productName"
                           label="产品名称"
                           min-width="140"
                           header-align="center">
            <template slot-scope="scope">
              <el-popover trigger="hover"
                          open-delay="200"
                          placement="top">
                <p>{{ scope.row.productName }}</p>
                <div slot="reference"
                     class="name-wrapper">{{ scope.row.productName }}</div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="sumABC"
                           label="ABC"
                           header-align="center"></el-table-column>
          <el-table-column prop="productTypeName"
                           label="分类"
                           header-align="center"></el-table-column>
          <el-table-column prop="salesPrice"
                           label="销售价"
                           header-align="center"
                           sortable
                           align="right"></el-table-column>
          <el-table-column prop="costPrice"
                           label="成本价"
                           header-align="center"
                           sortable
                           align="right"></el-table-column>
          <el-table-column prop="salesAmount"
                           label="销售量"
                           header-align="center"
                           sortable
                           align="right"></el-table-column>
          <el-table-column prop="salesAverAmount"
                           label="店均量"
                           header-align="center"
                           sortable
                           align="right"></el-table-column>
          <el-table-column prop="returnAmount"
                           label="报废量"
                           header-align="center"
                           sortable
                           align="right"></el-table-column>
          <el-table-column prop="returnPercent"
                           label="报废率"
                           header-align="center"
                           sortable
                           sort-by="returnPercent2"
                           align="right"></el-table-column>
          <el-table-column :prop="item.id"
                           :label="item.name"
                           v-for="(item,index) in tagColumn"
                           :key="index"
                           header-align="center"
                           align="center"
                           minWidth="120"
                           v-if="checkedBQ"></el-table-column>
        </el-table>
      </div>
      <el-dialog class="editDialog"
                 :title="editName"
                 :visible.sync="editDialogVisible"
                 width="70%"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 :modal-append-to-body="false">
        <p>
          展示价格区间商品设置，可查看价格区间中的商品和金额。
          <i class="el-icon-question show-example"
             @click="openExample(showExample)"></i>
          （范围为：0~最高价格）
        </p>
        <div class="example-content"
             v-bind:class="{ active:!showExample}">
          <p>价格带展示为:</p>
          <div id="example"></div>
        </div>
        <!-- <p>数据展示：0~7（取值小于等于7）、8（取值大于7）~15（小于等于15）、16~最大数值</p> -->
        <p class="show-detail"
           v-if="dynamicValidateForm.domains.length>0">
          数据展示：
          <span>
            <template v-for="(domain, index) in dynamicValidateForm.domains">
              <template v-if="index==0&&domain.value>0">0~{{domain.value}}（取值小于等于{{domain.value}}）</template>
              <template v-if="index>0&&domain.value">、{{dynamicValidateForm.domains[index-1].value}}（取值大于{{dynamicValidateForm.domains[index-1].value}}）~{{domain.value}}（取值小于等于{{domain.value}}）</template>
            </template>
            <template v-if="dynamicValidateForm.domains[dynamicValidateForm.domains.length-1].value">、{{dynamicValidateForm.domains[dynamicValidateForm.domains.length-1].value}}（取值大于{{dynamicValidateForm.domains[dynamicValidateForm.domains.length-1].value}}）~最大数值</template>
          </span>
        </p>
        <p>价格带区间:</p>
        <el-form :inline="true"
                 :model="dynamicValidateForm"
                 ref="dynamicValidateForm"
                 label-width="100px"
                 class="demo-dynamic">
          <el-form-item class="content"
                        v-for="(domain, index) in dynamicValidateForm.domains"
                        :key="domain.key"
                        :prop="'domains.' + index + '.value'"
                        :rules="[{
              required: true, message: '价格区间不能为空', trigger: 'blur'
            },{ pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,1})?$/, message: '请输入最多一位小数的数字', trigger: 'blur' },
            { validator: valiNumber, trigger: 'blur' }]">
            <el-input v-model.number="domain.value"></el-input>
            <i class="el-icon-error"
               @click.prevent="removeDomain(domain)"></i>
          </el-form-item>
          <el-form-item class="content"
                        v-if="dynamicValidateForm.domains.length<15">
            <el-button size="small"
                       @click="addDomain">新增</el-button>
          </el-form-item>
        </el-form>
        <div class="submit-form">
          <el-button type="primary"
                     size="small"
                     @click="submitForm('dynamicValidateForm')">保存</el-button>
          <el-button size="small"
                     @click="resetForm('dynamicValidateForm')">取消</el-button>
        </div>
      </el-dialog>
    </el-col>
  </el-row>
</template>
<script>
import echarts from "echarts";
import tdTheme from "./theme.json";
import deptApi from "@/api/api-dept";
import productApi from "@/api/api-product";
import common from "@/libs/common";
import { MessageBox } from "element-ui";
import { localToken } from "@/libs/util";
echarts.registerTheme("tdTheme", tdTheme);
let loading;
export default {
  data () {
    return {
      valiNumber: (rule, value, callback) => {
        let currentindex = Number(rule.field.split(".")[1]);
        //包含小数的数字
        let min = true;
        let max = true;
        this.dynamicValidateForm.domains.filter((item, index) => {
          if (item.value && currentindex > index && item.value >= value) {
            min = false;
          }
          if (item.value && currentindex < index && item.value <= value) {
            max = false;
          }
        });
        if (!min || !max) {
          callback(
            // 请输入大于上一个区间价格小于下一个区间价格的正确数据
            new Error("请输入正确的区间价格")
          );
        } else {
          callback();
        }
      },
      //时间
      pickerOptionsStart: {},
      pickerOptionsEnd: {},
      startTime: new Date(common.getPerDate()), // common.getPerDate(),
      endTime: new Date(common.getPerDate()),  // endTime: new Date(),
      labelPosition: "right",
      formLabelAlign: {
        name: "",
        region: "",
        type: ""
      },
      defaultProps: {
        children: "children",
        label: "label"
      },
      // 部门树
      deptOptions: [],
      // 区域
      areaId: ['all'],
      // 分类列表
      optionsProductType: [],
      valueProductType: [],
      optionsDept: [],
      valueDept: [],
      tableData: [],
      tagColumn: [], // 标签列表名称默认为空
      checkTreeList: ["1"],
      currentProductIds: [],
      currentPrice: null,
      price1: 0,
      price2: null,
      // effectData: [null, null],
      formattedData: [],
      res: [],
      res2: [],
      flag: 0,
      checkedBQ: true,
      radio: 1,
      editName: "价格区间设置",
      editDialogVisible: false,
      dynamicValidateForm: {
        domains: common.domainsList
      },
      showExample: false,
      oldSearchType: ["all"],
      oldSearchDeptType: ["all"],
      legendselect: 0,
      deptAreaList: [], // 0产品数量 1销售数量 2销售金额
      oldDeptArea: ["all"],
      oldDept: ["all"],
      typeList1: [],
      productTypeId1: [],
      oldProductType1: ["all"],
    };
  },
  methods: {
    // 切换中类 重新请求数据
    changeProductType1 (val) {
      let that = this
      const allValues = [];
      for (const item of that.typeList1) {
        allValues.push(item.productTypeId);
      }
      const oldVal =
        that.oldProductType1.length === 1 ? that.oldProductType1[0] : [];
      if (val.includes("all")) that.productTypeId1 = allValues
      if (oldVal.includes("all") && !val.includes("all"))
        that.productTypeId1 = []
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        that.productTypeId1 = val
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        if (val.length === allValues.length - 1)
          that.productTypeId1 = ["all"].concat(val)
      }
      that.oldProductType1[0] = that.productTypeId1;
      if (that.productTypeId1.length == 0) {
        that.valueProductType = [] // 当前选中分类
        that.optionsProductType = [] // 当前分类列表
        that.oldSearchType = []
      } else {
        let data = { TypeFlag: 0 }
        if (that.productTypeId1[0] !== 'all') { data["typeId"] = that.productTypeId1 }
        common.getProductTypeListByFLag(data).then(
          res => {
            that.optionsProductType = [{ productTypeId: "all", productTypeName: "全选" }].concat(res)
            that.valueProductType = that.optionsProductType.map(item => {
              return item.productTypeId
            })
            that.oldSearchType = ['all']
          },
          err => {
            console.log(err)
          }
        )
      }
    },
    // 切换区域，根据区域获取门店 重新请求数据
    changeArea (val) {
      let that = this
      const allValues = [];
      for (const item of that.deptAreaList) {
        allValues.push(item.id);
      }
      const oldVal =
        that.oldDeptArea.length === 1 ? that.oldDeptArea[0] : [];
      if (val.includes("all")) that.areaId = allValues
      if (oldVal.includes("all") && !val.includes("all"))
        that.areaId = []
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        that.areaId = val
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        if (val.length === allValues.length - 1)
          that.areaId = ["all"].concat(val)
      }
      that.oldDeptArea[0] = that.areaId;

      if (that.areaId.length == 0) {
        that.valueDept = []
        that.productTypeId1 = []
        that.valueProductType = []
        that.optionsDept = []
        that.optionsProductType = []
        that.oldDept = []
        that.oldProductType1 = []
        that.oldSearchType = []
      } else {
        let data = { AreaId: that.areaId[0] === 'all' ? [] : that.areaId }
        common.getDept(data).then(
          res => {
            that.optionsDept = [{ deptId: "all", deptName: "全选" }].concat(res)
            that.valueDept = that.optionsDept.map(item => {
              return item.deptId
            })
            that.oldDept = ['all']
          },
          err => {
            console.log(err)
          }
        )
      }
    },
    selectDeptAll (val) {
      const allValues = [];
      for (const item of this.optionsDept) {
        allValues.push(item.deptId);
      }
      const oldVal =
        this.oldSearchDeptType.length === 1 ? this.oldSearchDeptType[0] : [];
      if (val.includes("all")) this.valueDept = allValues;
      if (oldVal.includes("all") && !val.includes("all")) this.valueDept = [];
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        this.valueDept = val;
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        console.log(11);
        if (val.length === allValues.length - 1)
          this.valueDept = ["all"].concat(val);
      }
      this.oldSearchDeptType[0] = this.valueDept;
    },
    selectAll (val) {
      const allValues = [];
      for (const item of this.optionsProductType) {
        allValues.push(item.productTypeId);
      }
      const oldVal =
        this.oldSearchType.length === 1 ? this.oldSearchType[0] : [];
      if (val.includes("all")) this.valueProductType = allValues;
      if (oldVal.includes("all") && !val.includes("all"))
        this.valueProductType = [];
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        this.valueProductType = val;
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        console.log(11);
        if (val.length === allValues.length - 1)
          this.valueProductType = ["all"].concat(val);
      }
      this.oldSearchType[0] = this.valueProductType;
    },
    redioChange () {
      let that = this;
      if (that.radio == 1) {
        let domains = localToken.getDomains() || "";
        if (domains == "") {
          that.editDialogVisible = true;
          return false
        }
      }
      that.getProductPriceZone();
    },

    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let str = "";
          this.dynamicValidateForm.domains.filter((item, index) => {
            str +=
              item.value +
              (index >= this.dynamicValidateForm.domains.length - 1 ? "" : ",");
          });
          localToken.setDomains(str);
          this.editDialogVisible = false;
          this.getProductPriceZone();
          // alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
      this.editDialogVisible = false;
    },
    removeDomain (item) {
      var index = this.dynamicValidateForm.domains.indexOf(item);
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1);
      }
    },
    addDomain () {
      this.dynamicValidateForm.domains.push({
        value: "",
        key: Date.now()
      });
    },
    openExample (showExample) {
      this.showExample = !showExample;
      if (this.showExample) {
        this.drawExample();
      }
    },
    openEdit () {
      let that = this;
      let domains = localToken.getDomains() || "";
      let list = [];
      if (domains != "") {
        list = domains.split(",").map(item => {
          return { value: Number(item) };
        });
        that.$set(that.dynamicValidateForm, "domains", list);
      }
      that.editDialogVisible = true;
    },

    // 只能输入数字且只有一位小数
    proving1 (e) {
      let that = this;
      // this.form.skus[e].Price 是input的值
      // 先把非数字的都替换掉，除了数字和.
      that.price1 = that.price1.replace(/[^\d.]/g, "");
      // 必须保证第一个为数字而不是.
      that.price1 = that.price1.replace(/^\./g, "");
      // 保证只有出现一个.而没有多个.
      that.price1 = that.price1.replace(/\.{2,}/g, "");
      // 保证.只出现一次，而不能出现两次以上
      that.price1 = that.price1
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");

      let index = -1;
      for (let i in that.price1) {
        if (that.price1[i] === ".") {
          index = i;
        }
        if (index !== -1) {
          if (i - index > 1) {
            that.price1 = that.price1.substring(0, that.price1.length - 1);
          }
        }
      }

      if (that.price1 >= 10000) {
        that.price1 = 10000;
      }
    },
    // 只能输入数字且只有一位小数
    proving2 (e) {
      let that = this;
      // this.form.skus[e].Price 是input的值
      // 先把非数字的都替换掉，除了数字和.
      that.price2 = that.price2.replace(/[^\d.]/g, "");
      // 必须保证第一个为数字而不是.
      that.price2 = that.price2.replace(/^\./g, "");
      // 保证只有出现一个.而没有多个.
      that.price2 = that.price2.replace(/\.{2,}/g, "");
      // 保证.只出现一次，而不能出现两次以上
      that.price2 = that.price2
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      let index = -1;
      for (let i in that.price2) {
        if (that.price2[i] === ".") {
          index = i;
        }
        if (index !== -1) {
          if (i - index > 1) {
            that.price2 = that.price2.substring(0, that.price2.length - 1);
          }
        }
      }
      if (that.price2 >= 10000) {
        that.price2 = 10000;
      }
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
      } else {
        return "success-row";
      }
      return "";
    },
    cellStyle ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        // 指定列号
        return "color:#4e9bed";
      } else {
        return "";
      }
    },
    changeStart () {
      let that = this;
      that.pickerOptionsStart = Object.assign({}, that.pickerOptionsStart, {
        disabledDate: time => {
          return time.getTime() > that.endTime;
        }
      });
    },
    changeEnd () {
      let that = this;
      that.pickerOptionsEnd = Object.assign({}, that.pickerOptionsEnd, {
        disabledDate: time => {
          return time.getTime() < that.startTime;
        }
      });
    },
    //商品分类列表
    getProductTypeList () {
      return new Promise((resolve, reject) => {
        productApi
          .getProductTypeList()
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getProductPriceZone (flag = false) {
      let that = this;

      if (!that.areaId || that.areaId.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先选择区域！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      let valueDept = that.valueDept;
      if (!valueDept || valueDept.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先选择门店！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      if (!that.productTypeId1 || that.productTypeId1.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先选择中类！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      let valueProductType = that.valueProductType;
      if (!valueProductType || valueProductType.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先选择小类！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      if (!flag) {
        loading = that.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.6)"
        });
      }
      that.tableData = []; //置空详情
      that.currentProductIds = [];
      that.currentPrice = null;
      let startTime = common.getTime(that.startTime) + " 00:00:00";
      let endTime = common.getTime(that.endTime) + " 23:59:59";
      let data = {
        productTypeId: valueProductType.filter(item => item != 'all'),
        // valueProductType.length == that.optionsProductType.length
        //   ? []
        //   : valueProductType,
        minPrice: parseFloat(that.price1 + ""),
        maxPrice: parseFloat(that.price2 + ""),
        priceType: that.radio, // 0按单个价格展示 1按价格区间展示
        deptId: valueDept.filter(item => item != 'all'), //valueDept.length == that.optionsDept.length ? [] : valueDept,
        beginDate: startTime,
        endDate: endTime
      };
      if (that.radio == 1) {
        data["searchType"] = that.legendselect; // 0数量 1销量 2金额
        let domains = localToken.getDomains() || "";
        let list = [];
        if (domains != "") {
          list = domains.split(",").map(item => {
            return Number(item);
          });
        } else {
          list = [0];
        }
        data["priceRange"] = list; // 价格区间
      }
      productApi.getProductPriceZone(data).then(
        res => {
          // 渲染0按单个价格展示 1按价格区间展示
          if (!flag) {
            loading.close();
          }

          if (that.radio == 0) {
            let formattedData = res.map(item => {
              return {
                value: [item.price, item.items.length],
                itemStyle: {
                  color: "#3f78e3"
                }
              };
            });
            that.formattedData = formattedData;
            that.res = res;
            let dom = echarts.init(that.$refs["dom1"], "tdTheme");
            dom.clear();
            that.getImage();
            if (res.length > 0) {
              if (flag) {
                that.price1 = Number(res[0].price);
                that.price2 = Number(res[res.length - 1].price);
              }
            }
            console.log("获取价格带数据", res);
          } else {
            let formattedData = res.map(item => {
              return {
                amount: [item.price, item.items.length],
                itemStyle: {
                  color: "#3f78e3"
                }
              };
            });
            that.formattedData = formattedData;
            that.res2 = res;
            that.drawLine(res);
          }
          // priceType: that.radio,
        },
        err => {
          if (!flag) {
            loading.close();
          }
        }
      );
    },
    // 商品价格分析列表
    getProductPriceDetail (productIds, salesPrice) {
      let that = this;
      if (!productIds || productIds.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h(
              "p",
              { class: "message-login-content" },
              "请先在顶部散点图中选择商品信息！ "
            )
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      if (!that.areaId || that.areaId.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先选择区域！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      let valueDept = that.valueDept;
      if (!valueDept || valueDept.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先选择门店！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      if (!that.productTypeId1 || that.productTypeId1.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先选择中类！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      let valueProductType = that.valueProductType;
      if (!valueProductType || valueProductType.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先选择小类！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      let startTime = common.getTime(that.startTime) + " 00:00:00";
      let endTime = common.getTime(that.endTime) + " 23:59:59";
      let data = {
        deptId: valueDept,//valueDept.length == that.optionsDept.length ? [] : valueDept,
        beginDate: startTime,
        endDate: endTime,
        productId: productIds,
        productTypeId: valueProductType,
        // valueProductType.length == that.optionsProductType.length
        //   ? []
        //   : valueProductType,
        // salesPrice: Number(salesPrice)
      };
      loading = that.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.6)"
      });
      productApi.getProductPriceDetail(data).then(
        res => {
          let arr = [];
          res = res.map(item => {
            arr = arr.concat(item.tag);
            item.tag.map(opt => {
              item[opt.id] = opt.value ? opt.value : null;
            });
            item["salesAverAmount"] = Math.trunc(item.salesAverAmount)
            item["returnPercent2"] = parseFloat(item.returnPercent.replace('%', ''))
            return item;
          });
          // 去重复，获取标签列表
          let id = "id"; //这里定义按照过滤的对象的属性名称
          that.tagColumn = arr.reduce(
            (all, next) =>
              all.some(item => item[id] == next[id]) ? all : [...all, next],
            []
          );
          that.tableData = res;
          loading.close();
        },
        err => {
          loading.close();
        }
      );
    },
    getImage () {
      let that = this;
      let data = that.formattedData;
      let res = that.res;
      // let effectData = that.effectData;
      that.$nextTick(() => {
        let option = {
          title: {
            text: "",
            subtext: "",
            x: "center"
          },
          tooltip: {
            enterable: true,
            triggerOn: "click",
            formatter: function (params) {
              let arr = res[params.dataIndex].items;
              let str = "";
              let productIds = [];
              arr.map(item => {
                str += item.productName + "<br/>";
                productIds.push(item.productId);
              });

              that.currentProductIds = productIds;
              that.currentPrice = res[params.dataIndex].price;
              that.currentLength = arr.length;
              for (var i = 0; i < data.length; i++) {
                data[i] = {
                  value: data[i].value,
                  itemStyle: {
                    borderColor:
                      data[i].value[0] == res[params.dataIndex].price &&
                        data[i].value[1] == arr.length
                        ? "#66b1ff"
                        : "rgba(255, 255, 255,0)",
                    borderWidth: 10
                  }
                };
              }
              that.formattedData = data;
              let dom = echarts.init(that.$refs["dom1"], "tdTheme");
              dom.setOption(option);
              that.getProductPriceDetail(
                productIds,
                res[params.dataIndex].price
              );
              that.flag += 1;
              return (
                "价格 :" +
                Number(params.value[0]) +
                "<br/>产品种类 :" +
                params.value[1] +
                "<br/>" +
                str
              );
            },
            position: function (point, params, dom, rect, size) {
              // 其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
              let x = point[0]; //
              let y = point[1];
              let boxWidth = size.contentSize[0];
              let boxHeight = size.contentSize[1];
              let posX = 0; // x坐标位置
              let posY = 0; // y坐标位置

              if (x < boxWidth) {
                // 左边放不开
                posX = 5;
              } else {
                // 左边放的下
                posX = x - boxWidth;
              }

              if (y < boxHeight) {
                // 上边放不开
                posY = 5;
              } else {
                // 上边放得下
                posY = y - boxHeight;
              }

              return [posX, posY];
            }
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            name: "价格",
            nameTextStyle: {
              fontSize: 14
            }
          },
          yAxis: {
            name: "数量",
            nameTextStyle: {
              fontSize: 14
            },
            minInterval: 1
          },
          series: [
            {
              name: "",
              symbolSize: 10,
              data: data,
              type: "scatter"
            }
          ]
        };
        let dom2 = echarts.init(that.$refs["dom2"], "tdTheme");
        dom2.setOption(option);
        dom2.dispatchAction({ type: "showTip" });
      });
    },
    drawExample () {
      let that = this;
      let example = that.$echarts.init(document.getElementById("example"));
      example.setOption({
        color: ["#FF7076", "#60D0FF", "#FFAF7A"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        legend: {
          left: "1%",
          selectedMode: "single" // 单选
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            data: ["0~5", "6~8", "8~12"]
          }
        ],
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            name: "产品数量",
            type: "bar",
            barGap: 0,
            data1: ["20%", "20%"],
            data: [20, 90, 90]
          },
          {
            name: "销售数量",
            type: "bar",
            data: [29, 190, 20]
          },
          {
            name: "销售金额",
            type: "bar",
            data: [25, 50, 10]
          }
        ]
      });
    },
    drawLine () {
      let that = this;
      let data = that.formattedData;
      that.$nextTick(() => {
        let res = JSON.parse(JSON.stringify(this.res2));
        let xAxisData = [];
        let seriesData = [];
        let total = 0
        res.filter(item => {
          xAxisData.push(item.price);
          seriesData.push(item.amount);
          total += item.amount
        });
        let option = {
          color: ["#FF7076", "#60D0FF", "#FFAF7A"],
          tooltip: {
            enterable: true,
            triggerOn: "click",
            formatter: function (params) {
              let arr = res[params.dataIndex].items;
              let str = "";
              let productIds = [];
              arr.map(item => {
                str += item.productName + "<br/>";
                productIds.push(item.productId);
              });

              that.currentProductIds = productIds;
              that.currentPrice = res[params.dataIndex].price;
              that.currentLength = arr.length;
              for (var i = 0; i < data.length; i++) {
                data[i] = {
                  amount: data[i].amount,
                  itemStyle: {
                    borderColor:
                      data[i].amount[0] == res[params.dataIndex].price &&
                        data[i].amount[1] == arr.length
                        ? "#66b1ff"
                        : "rgba(255, 255, 255,0)",
                    borderWidth: 10
                  }
                };
              }
              that.getProductPriceDetail(
                productIds,
                res[params.dataIndex].price
              );
              // that.flag += 1;
              return (
                params.seriesName +
                Number(params.value) +
                "<br/>产品种类 :" +
                Number(params.value) +
                "<br/>" +
                str
              );
            },
            position: function (point, params, dom, rect, size) {
              // 其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
              let x = point[0]; //
              let y = point[1];
              let boxWidth = size.contentSize[0];
              let boxHeight = size.contentSize[1];
              let posX = 0; // x坐标位置
              let posY = 0; // y坐标位置

              if (x < boxWidth) {
                // 左边放不开
                posX = 5;
              } else {
                // 左边放的下
                posX = x - boxWidth;
              }

              if (y < boxHeight) {
                // 上边放不开
                posY = 5;
              } else {
                // 上边放得下
                posY = y - boxHeight;
              }

              return [posX, posY];
            }
          },
          legend: {
            left: "3%",
            itemGap: 25,
            selectedMode: "single", // 单选
            selected: {
              产品数量: that.legendselect == 0,
              销售数量: that.legendselect == 1,
              销售金额: that.legendselect == 2
            }
          },
          grid: {
            left: "2%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: [
            {
              type: "category",
              data: xAxisData
            }
          ],
          yAxis: [
            {
              type: "value"
            }
          ],
          series: [
            {
              name: "产品数量",
              type: "bar",
              barGap: 0,
              barMaxWidth: 80, // 最大宽度
              data: seriesData,
              itemStyle: {
                normal: {
                  label: {
                    show: true,//是否显示 
                    position: 'top',//显示位置 
                    formatter: function (params) {//核心部分 formatter 可以为字符串也可以是回调 
                      if (params.value) {//如果当前值存在则拼接
                        return params.value + '(' + common.toDecimal2(common.floatDiv(params.value, total) * 100) + '%)'
                      } else {//否则返回个空
                        return '';
                      }
                    }
                  }
                }
              }
              // label: {
              //   show: true,
              //   position: 'top',
              //   textStyle: {	    //数值样式
              //     color: 'black'
              //   }
              // }
            },
            {
              name: "销售数量",
              type: "bar",
              barMaxWidth: 80, // 最大宽度
              data: seriesData,
              itemStyle: {
                normal: {
                  label: {
                    show: true,//是否显示 
                    position: 'top',//显示位置 
                    formatter: function (params) {//核心部分 formatter 可以为字符串也可以是回调 
                      if (params.value) {//如果当前值存在则拼接
                        return params.value + '(' + common.toDecimal2(common.floatDiv(params.value, total) * 100) + '%)'
                      } else {//否则返回个空
                        return '';
                      }
                    }
                  }
                }
              }
            },
            {
              name: "销售金额",
              type: "bar",
              barMaxWidth: 80, // 最大宽度
              data: seriesData,
              itemStyle: {
                normal: {
                  label: {
                    show: true,//是否显示 
                    position: 'top',//显示位置 
                    formatter: function (params) {//核心部分 formatter 可以为字符串也可以是回调 
                      if (params.value) {//如果当前值存在则拼接
                        return params.value + '(' + common.toDecimal2(common.floatDiv(params.value, total) * 100) + '%)'
                      } else {//否则返回个空
                        return '';
                      }
                    }
                  }
                }
              }
            }
          ]
        };
        let dom3 = echarts.init(that.$refs["dom3"], "tdTheme");
        dom3.setOption(option);
        dom3.dispatchAction({ type: "showTip" });
      });
      // 基于准备好的dom，初始化echarts实例
      let myChart = that.$echarts.init(document.getElementById("myChart"));
      // let xAxisData = [];
      // let seriesData = [];
      // data.filter(item => {
      //   xAxisData.push(item.price);
      //   seriesData.push(item.amount);
      // });
      // 绘制图表
      // myChart.setOption({
      //   color: ["#FF7076", "#60D0FF", "#FFAF7A"],
      //   // tooltip: {
      //   //   trigger: "axis",
      //   //   axisPointer: {
      //   //     type: "shadow"
      //   //   }
      //   // },
      //   tooltip: {
      //     enterable: true,
      //     triggerOn: "click",
      //     formatter: function(params) {
      //       let arr = data[params.dataIndex].items;
      //       let str = "";
      //       let productIds = [];
      //       arr.map(item => {
      //         str += item.productName + "<br/>";
      //         productIds.push(item.productId);
      //       });

      //       that.currentProductIds = productIds;
      //       that.currentPrice = data[params.dataIndex].price;
      //       that.currentLength = arr.length;
      //       for (var i = 0; i < data.length; i++) {
      //         data[i] = {
      //           amount: data[i].amount,
      //           itemStyle: {
      //             borderColor:
      //               data[i].amount[0] == data[params.dataIndex].price &&
      //               data[i].amount[1] == arr.length
      //                 ? "#66b1ff"
      //                 : "rgba(255, 255, 255,0)",
      //             borderWidth: 10
      //           }
      //         };
      //       }
      //       // that.formattedData = data;
      //       // let dom = echarts.init(that.$refs["dom1"], "tdTheme");
      //       // dom.setOption(option);
      //       that.getProductPriceDetail(
      //         productIds,
      //         data[params.dataIndex].price
      //       );
      //       // that.flag += 1;
      //       return (
      //         "价格 :" +
      //         Number(params.value[0]) +
      //         "<br/>产品种类 :" +
      //         params.value[1] +
      //         "<br/>" +
      //         str
      //       );
      //     },
      //     position: function(point, params, dom, rect, size) {
      //       // 其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
      //       let x = point[0]; //
      //       let y = point[1];
      //       let boxWidth = size.contentSize[0];
      //       let boxHeight = size.contentSize[1];
      //       let posX = 0; // x坐标位置
      //       let posY = 0; // y坐标位置

      //       if (x < boxWidth) {
      //         // 左边放不开
      //         posX = 5;
      //       } else {
      //         // 左边放的下
      //         posX = x - boxWidth;
      //       }

      //       if (y < boxHeight) {
      //         // 上边放不开
      //         posY = 5;
      //       } else {
      //         // 上边放得下
      //         posY = y - boxHeight;
      //       }

      //       return [posX, posY];
      //     }
      //   },
      //   legend: {
      //     left: "3%",
      //     itemGap: 25,
      //     selectedMode: "single", // 单选
      //     selected: {
      //       产品数量: that.legendselect == 0,
      //       销售数量: that.legendselect == 1,
      //       销售金额: that.legendselect == 2
      //     }
      //   },
      //   grid: {
      //     left: "2%",
      //     right: "4%",
      //     bottom: "3%",
      //     containLabel: true
      //   },
      //   xAxis: [
      //     {
      //       type: "category",
      //       // axisTick: { show: false },
      //       data: xAxisData
      //     }
      //   ],
      //   yAxis: [
      //     {
      //       type: "value"
      //     }
      //   ],
      //   series: [
      //     {
      //       name: "产品数量",
      //       type: "bar",
      //       barGap: 0,
      //       barMaxWidth: 80, // 最大宽度
      //       // label: labelOption,
      //       data: seriesData
      //     },
      //     {
      //       name: "销售数量",
      //       type: "bar",
      //       barMaxWidth: 80, // 最大宽度
      //       // label: labelOption,
      //       data: seriesData
      //     },
      //     {
      //       name: "销售金额",
      //       type: "bar",
      //       barMaxWidth: 80, // 最大宽度
      //       // label: labelOption,
      //       data: seriesData
      //     }
      //   ]
      // });
      myChart.on("legendselectchanged", function (obj) {
        var legend = obj.name;
        that.legendselect =
          legend == "产品数量" ? 0 : legend == "销售数量" ? 1 : 2;
        that.getProductPriceZone(false);
      });

      //  myChart.getZr().on('click', params => {
      //           let pointInPixel = [params.offsetX, params.offsetY]
      //           if (myChart.containPixel('grid', pointInPixel)) {
      //             let xIndex = myChart.convertFromPixel({ seriesIndex: 0 }, [params.offsetX, params.offsetY])[0]
      //             console.log(xIndex)
      //           }
      //         })
      // myChart.on("click", function(params) {
      //   // alert(params);
      //   console.log(params);
      // });
    },
    init () {
      let that = this;
      loading = that.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.6)"
      });
      that.changeStart();
      that.changeEnd();

      Promise.all([common.getDept({
        "areaId": []
      }), that.getProductTypeList(),
      common.getDeptArea(),
      common.getProductTypeListByFLag({ typeFlag: 1 })])
        .then(
          res => {
            loading.close();
            //部门对应列表
            that.optionsDept = [
              {
                deptId: "all",
                deptName: "全选"
              }
            ].concat(res[0]);
            that.valueDept =
              res[0].length > 0
                ? that.optionsDept.map(item => {
                  return item.deptId;
                })
                : [];
            //商品ABC对应分类列表
            that.optionsProductType = [
              {
                productTypeId: "all",
                productTypeName: "全选"
              }
            ].concat(res[1]);
            that.valueProductType =
              res[1].length > 0
                ? that.optionsProductType.map(item => {
                  return item.productTypeId;
                })
                : [];
            // 区域
            that.deptAreaList = [{ id: "all", name: "全选" }].concat(res[2])
            that.areaId = that.deptAreaList.map(item => {
              return item.id
            })
            // 中类
            that.typeList1 = [{ productTypeId: "all", productTypeName: "全选" }].concat(res[3])
            that.productTypeId1 = that.typeList1.map(item => {
              return item.productTypeId
            })
            that.getProductPriceZone(true);
          },
          err => {
            loading.close();
          }
        )
        .catch(error => {
          loading.close();
        });
    }
  },
  mounted () {
    let that = this;
    that.init();
    that.drawLine();
  },
  destroyed () {
    loading.close();
  }
};
</script>
<style lang="less">
.el-table .success-row {
  background: #eef7ff;
}
</style>


// WEBPACK FOOTER //
// src/view/main/priceAnalysis.vue